import axios from 'axios';
import { eventTypeTracking } from './types';

const trackingService = (eventType: eventTypeTracking) =>
  axios.create({
    baseURL: process.env.API_GATEWAY_URL,
    timeout: 60000,
    headers: {
      'content-Type': 'application/json',
      'Event-Type': eventType,
      Accept: '/',
      'Cache-Control': 'no-cache',
    },
  });

export { trackingService };
